import CheckEmails from "@/components/forget-password/CheckEmails";
import Confirmation from "@/components/forget-password/Confirmation";
import ForgetPasswordMain from "@/components/forget-password/ForgetPassword";
import UpdatePassword from "@/components/forget-password/UpdatePassword";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const ForgetPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);
  const [searchParams] = useSearchParams();

  const backgroundImageUrl = t("loginBackgroundImageUrl", { defaultValue: "" });

  useEffect(() => {
    if (searchParams.get("step")) {
      setStep(Number(searchParams.get("step")));
    }
  }, [searchParams]);

  return (
    <div className="w-full h-full justify-between items-center inline-flex">
      <div className="w-full h-screen relative">
        {step === 1 && (
          <ForgetPasswordMain
            onNext={() => setStep(2)}
            email={email}
            setEmail={setEmail}
          />
        )}
        {step === 2 && <CheckEmails onNext={() => setStep(3)} email={email} />}
        {step === 3 && <UpdatePassword onNext={() => setStep(4)} />}
        {step === 4 && <Confirmation />}
        <div className="absolute bottom-0 w-full h-16 px-12 py-5 bg-white border-t border-slate-200 flex justify-between items-center">
          <div className="text-center text-slate-700 text-sm font-semibold font-['Raleway'] leading-normal">
            © InventoZen 2024 | version: {import.meta.env.VITE_CURRENT_GIT_SHA}
          </div>
          <div className="justify-start items-start gap-5 flex">
            <a
              href={"#"}
              className="text-[#006eab] text-sm font-bold font-['Raleway'] leading-normal"
            >
              {t("CGV")}
            </a>
            <div className="text-center text-slate-700 text-sm font-semibold font-['Raleway'] leading-normal">
              |
            </div>
            <a
              href={"#"}
              className="text-[#006eab] text-sm font-bold font-['Raleway'] leading-normal"
            >
              {t("footerLegalNotices")}
            </a>
            <div className="text-center text-slate-700 text-sm font-semibold font-['Raleway'] leading-normal">
              |
            </div>
            <p className="text-[#006eab] text-sm font-bold font-['Raleway'] leading-normal">
              {t("optimizeForChrome")}
            </p>
          </div>
        </div>
      </div>
      <div
        className={cn(
          "h-screen relative md:hidden lg:block transition-all duration-300",
          backgroundImageUrl ? "w-[50%]" : "w-0",
        )}
      >
        {backgroundImageUrl && (
          <img
            src={backgroundImageUrl}
            alt="login"
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute bottom-0 left-0 w-full flex-col justify-center items-center inline-flex">
          <div className="self-stretch p-8 bg-white/10 border-t border-white/10 backdrop-blur-xl flex-col justify-start items-start gap-8 flex">
            <div className="h-14 flex-col justify-start items-start gap-1 flex">
              <p className="grow shrink basis-0 text-white text-xl font-semibold font-['Instrument Sans'] leading-normal text-left">
                {t("titleOfTheWork")}
              </p>
              <p className="self-stretch text-white text-lg font-normal font-['Raleway'] leading-normal text-left">
                {t("artistFirstPage")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
